module.exports = __webpack_public_path__ + "static/media/dyer_delama_pinholster.e8fdbecb.jpg";